<template>
  <div class="main-container">
    <!-- 左侧导航 -->
    <div class="sidebar">
      <div class="sidebar-header">
        <div class="logo-area">
          <img :src="shopLogo" alt="logo" class="logo-img" />
          <span class="logo-text" v-if="!isCollapse">{{ shopName }}</span>
        </div>
      </div>

      <div class="sidebar-divider"></div>

      <el-menu class="nav-menu" :default-active="activeMenu" :background-color="menuBgColor" text-color="#94a3b8"
        active-text-color="#e2e8f0" router :collapse="isCollapse" unique-opened>
        <!-- 控制台 -->
        <el-menu-item index="/dashboard">
          <el-icon>
            <Monitor />
          </el-icon>
          <span>控制台</span>
        </el-menu-item>

        <!-- 账号管理 -->
        <el-menu-item index="/account">
          <el-icon>
            <User />
          </el-icon>
          <span>账号管理</span>
        </el-menu-item>

        <!-- 文章管理 -->
        <el-sub-menu index="/article">
          <template #title>
            <el-icon>
              <Document />
            </el-icon>
            <span>文章管理</span>
          </template>
          <el-menu-item index="/article/category">
            <el-icon>
              <Folder />
            </el-icon>
            <span>文章分类</span>
          </el-menu-item>
          <el-menu-item index="/article/create">
            <el-icon>
              <EditPen />
            </el-icon>
            <span>文章创作</span>
          </el-menu-item>
          <el-menu-item index="/article/greenbook">
            <el-icon>
              <Notebook />
            </el-icon>
            <span>绿书创作</span>
          </el-menu-item>
          <el-menu-item index="/article/list">
            <el-icon>
              <List />
            </el-icon>
            <span>文章列表</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 爆文改写 -->
        <el-menu-item index="/rewrite">
          <el-icon>
            <MagicStick />
          </el-icon>
          <span>爆文改写</span>
        </el-menu-item>

        <!-- 消费日志 -->
        <el-menu-item index="/consumption-log">
          <el-icon>
            <Coin />
          </el-icon>
          <span>消费日志</span>
        </el-menu-item>

        <!-- 绿书发布 -->
        <el-sub-menu index="/greenbook">
          <template #title>
            <el-icon>
              <Upload />
            </el-icon>
            <span>绿书发布</span>
          </template>
          <el-menu-item index="/greenbook/draft">
            <el-icon>
              <DocumentCopy />
            </el-icon>
            <span>草稿任务</span>
          </el-menu-item>
          <el-menu-item index="/greenbook/record">
            <el-icon>
              <Clock />
            </el-icon>
            <span>发布记录</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 文章发布 -->
        <el-sub-menu index="/publish">
          <template #title>
            <el-icon>
              <Promotion />
            </el-icon>
            <span>文章发布</span>
          </template>
          <el-menu-item index="/publish/draft">
            <el-icon>
              <DocumentCopy />
            </el-icon>
            <span>草稿任务</span>
          </el-menu-item>
          <el-menu-item index="/publish/record">
            <el-icon>
              <Clock />
            </el-icon>
            <span>发布记录</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 素材管理 -->
        <el-sub-menu index="/material">
          <template #title>
            <el-icon>
              <Picture />
            </el-icon>
            <span>素材管理</span>
          </template>
          <el-menu-item index="/material/title">
            <el-icon>
              <CollectionTag />
            </el-icon>
            <span>下拉词库</span>
          </el-menu-item>
          <el-menu-item index="/material/gallery">
            <el-icon>
              <Picture />
            </el-icon>
            <span>图库管理</span>
          </el-menu-item>
          <el-menu-item index="/material/header-ad">
            <el-icon>
              <VideoPlay />
            </el-icon>
            <span>头部广告</span>
          </el-menu-item>
          <el-menu-item index="/material/footer-ad">
            <el-icon>
              <VideoPause />
            </el-icon>
            <span>尾部广告</span>
          </el-menu-item>
          <el-menu-item index="/material/call">
            <el-icon>
              <Phone />
            </el-icon>
            <span>一键拨号</span>
          </el-menu-item>
          <el-menu-item index="/material/knowledge" v-if="pluginStatus.rwjh_zsk">
            <el-icon>
              <Collection />
            </el-icon>
            <span>知识云库</span>
          </el-menu-item>
        </el-sub-menu>

        <!-- 系统配置子菜单 -->
        <el-sub-menu index="/system">
          <template #title>
            <el-icon>
              <Setting />
            </el-icon>
            <span>系统配置</span>
          </template>

          <el-menu-item index="/system/Moban" v-if="moduleStatus.tweet_template === 2">
            <el-icon>
              <Memo />
            </el-icon>
            <span>推文模版</span>
          </el-menu-item>

          <el-menu-item index="/system/model" v-if="moduleStatus.writing_model === 2">
            <el-icon>
              <Cpu />
            </el-icon>
            <span>写作模型</span>
          </el-menu-item>

          <el-menu-item index="/system/medium-api" v-if="moduleStatus.media_model === 2">
            <el-icon>
              <Camera />
            </el-icon>
            <span>媒体模型</span>
          </el-menu-item>

          <el-menu-item index="/system/title-api" v-if="moduleStatus.title_api === 2">
            <el-icon>
              <Connection />
            </el-icon>
            <span>标题接口</span>
          </el-menu-item>

          <el-menu-item index="/system/command">
            <el-icon>
              <MagicStick />
            </el-icon>
            <span>创作指令</span>
          </el-menu-item>

          <el-menu-item index="/system/clever" v-if="moduleStatus.ai_agent === 2">
            <el-icon>
              <Eleme />
            </el-icon>
            <span>AI智能体</span>
          </el-menu-item>

          <el-menu-item index="/system/OssConfig" v-if="moduleStatus.storage_config === 2">
            <el-icon>
              <FolderChecked />
            </el-icon>
            <span>存储配置</span>
          </el-menu-item>

          <el-menu-item index="/system/publish">
            <el-icon>
              <SetUp />
            </el-icon>
            <span>基础设置</span>
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 右侧内容区 -->
    <div class="content-wrapper">
      <!-- 固定在顶部的导航栏 -->
      <div class="top-navbar fixed-top">
        <div class="nav-center">
          <div class="info-item">
            <span class="info-dot dot-points"></span>
            <span class="info-label">点数</span>
            <span class="info-value">{{ points === -1 ? '无限制' : points.toFixed(1) }}</span>
          </div>
          <div class="info-item">
            <span class="info-dot dot-auth"></span>
            <span class="info-label">授权数</span>
            <span class="info-value">{{ sqNum === -1 ? '无限制' : sqNum }}</span>
          </div>
          <div class="info-item">
            <span class="info-dot dot-expire"></span>
            <span class="info-label">过期时间</span>
            <span class="info-value">{{ formattedOutDate }}</span>
          </div>
        </div>

        <div class="nav-right">
          <el-dropdown trigger="hover">
            <div class="user-info">
              <el-avatar :size="32" :src="userAvatar" />
              <span class="username">{{ username }}</span>
              <el-icon class="arrow-icon"><ArrowDown /></el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="showCardRechargeDialog">
                  <el-icon><CreditCard /></el-icon>卡密充值
                </el-dropdown-item>
                <el-dropdown-item @click="handleModifyPassword">
                  <el-icon><Edit /></el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleLogout">
                  <el-icon><SwitchButton /></el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 主内容区 -->
      <div class="main-content-container">
        <div class="main-content">
          <router-view />
        </div>
      </div>
    </div>
  </div>
  <!-- 卡密充值对话框 -->
  <el-dialog v-model="showCardDialog" title="卡密充值" width="400px" :close-on-click-modal="false">
    <el-form :model="cardForm" label-width="80px">
      <el-form-item label="卡密">
        <el-input v-model="cardForm.code" placeholder="请输入充值卡密" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showCardDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitCardRecharge">确 定</el-button>
    </template>
  </el-dialog>

  <el-dialog v-model="showPasswordDialog" title="修改密码" width="400px" :close-on-click-modal="false">
    <el-form :model="form" label-width="80px">
      <el-form-item label="旧密码">
        <el-input v-model="form.oldPwd" type="password" placeholder="请输入旧密码" show-password />
      </el-form-item>
      <el-form-item label="新密码">
        <el-input v-model="form.newPwd" type="password" placeholder="请输入新密码" show-password />
      </el-form-item>
      <el-form-item label="确认密码">
        <el-input v-model="form.confirmPwd" type="password" placeholder="请再次输入新密码" show-password />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="showPasswordDialog = false">取 消</el-button>
      <el-button type="primary" @click="submitPassword">确 定</el-button>
    </template>
  </el-dialog>


</template>

<script>
import {
  Monitor,
  User,
  Document,
  Folder,
  EditPen,
  Notebook,
  List,
  MagicStick,
  Upload,
  DocumentCopy,
  Clock,
  Promotion,
  Picture,
  CollectionTag,
  VideoPlay,
  VideoPause,
  Phone,
  Setting,
  Cpu,
  Connection,
  Eleme,
  CreditCard,
  Camera,
  Memo,
  FolderChecked,
  SetUp,
  Collection
} from '@element-plus/icons-vue'
import { ref, computed, onMounted, reactive } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import Cookies from 'js-cookie'
import config from '@/config'
import axios from 'axios'



export default {
  name: 'MainLayout',
  components: {
    Monitor,
    CreditCard,
    User,
    Document,
    Folder,
    EditPen,
    Notebook,
    List,
    MagicStick,
    Upload,
    DocumentCopy,
    Clock,
    Promotion,
    Picture,
    CollectionTag,
    VideoPlay,
    VideoPause,
    Phone,
    Setting,
    Cpu,
    Connection,
    Eleme,
    SetUp,
    Camera,
    Memo,
    FolderChecked,
    Collection
  },

  setup() {
    const router = useRouter()


    // 正确的 ref 定义（去掉多余空格）
    const moduleStatus = ref({
      tweet_template: 2,
      writing_model: 2,
      media_model: 2,
      title_api: 2,
      ai_agent: 2,
      storage_config: 2
    });

    // 插件市场授权状态（控制插件菜单项显隐）
    const pluginStatus = ref({
      rwjh_zsk: false
    });
    const userInfo = JSON.parse(Cookies.get('user_info') || '{}')
    const account = userInfo.account || ''
    const isLoggedIn = ref(!!Cookies.get('user_token'))
    const shopLogo = ref('@/assets/logo.gif') // 默认logo
    const shopName = ref('商户端') // 默认名称
    const menuBgColor = ref('transparent')
    const isCollapse = ref(false)
    const points = ref(0) // 初始化为0
    const sqNum = ref(0)
    const outDate = ref('')
    const formattedOutDate = computed(() => outDate.value.split(' ')[0] || '未设置')
    const userAvatar = ref('https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png')
    const username = ref(account)

    const activeMenu = computed(() => {
      const route = router.currentRoute.value
      const matched = route.matched
      return matched.length > 1 ? `/${matched[0].path.split('/')[1]}` : route.path
    })
    const showPasswordDialog = ref(false)
    const form = reactive({
      oldPwd: '',
      newPwd: '',
      confirmPwd: ''
    })
    const showCardDialog = ref(false)
    const cardForm = reactive({
      code: ''
    })

    // 显示卡密充值对话框
    const showCardRechargeDialog = () => {
      cardForm.code = ''
      showCardDialog.value = true
    }

    // 获取模块权限状态
    const fetchModuleStatus = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/module_hidden.php`, {
          store_id: userInfo.id
        });

        if (response.data.data) {
          moduleStatus.value = response.data.data;
        }
      } catch (error) {
        console.error('获取模块权限失败:', error);
        // 使用默认全选状态
        moduleStatus.value = {
          tweet_template: 2,
          writing_model: 2,
          media_model: 2,
          title_api: 2,
          ai_agent: 2,
          storage_config: 2
        };
      }
    };

    // 获取插件市场授权状态
    const fetchPluginStatus = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/check_plugin.php`, {
          store_id: userInfo.id
        });

        if (response.data.data) {
          pluginStatus.value = response.data.data;
        }
      } catch (error) {
        console.error('获取插件权限失败:', error);
        // 出错了默认全部关闭
        pluginStatus.value = {};
      }
    };

    // 提交卡密充值
    const submitCardRecharge = async () => {
      if (!cardForm.code) {
        ElMessage.error('请输入卡密')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'recharge_card',
          account: account,
          code: cardForm.code
        })

        if (response.data.success) {
          ElMessage.success('充值成功')
          // 刷新点数信息
          await loadPoints()
          showCardDialog.value = false
        } else {
          ElMessage.error(response.data.message || '充值失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      }
    }

    // 加载点数数据
    const loadPoints = async () => {
      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'query',
          account: account
        })

        if (response.data.success) {
          points.value = parseFloat(response.data.data.dianshu || 0)
          sqNum.value = parseInt(response.data.data.sq_num) || 0 // 新增 parseInt 转换

          outDate.value = response.data.data.out_date || ''

        } else {
          ElMessage.error('点数加载失败: ' + (response.data.message || '未知错误'))
        }
      } catch (error) {
        ElMessage.error('接口请求失败: ' + error.message)
      }
    }

    // 修改密码方法
    const submitPassword = async () => {
      // 前端验证
      if (!form.oldPwd) {
        ElMessage.error('请输入旧密码')
        return
      }
      if (!form.newPwd) {
        ElMessage.error('请输入新密码')
        return
      }
      if (form.newPwd !== form.confirmPwd) {
        ElMessage.error('两次输入的新密码不一致')
        return
      }

      try {
        const response = await axios.post(`${config.BASE_URL}/shop/api/shop_api.php`, {
          action: 'update_password',
          account: account,
          old_password: form.oldPwd,
          new_password: form.newPwd
        })

        if (response.data.success) {
          ElMessage.success('密码修改成功，请重新登录')
          // 清除登录状态
          Cookies.remove('user_token')
          router.push('/login')
        } else {
          ElMessage.error(response.data.message || '密码修改失败')
        }
      } catch (error) {
        ElMessage.error(error.response?.data?.message || '请求失败')
      } finally {
        showPasswordDialog.value = false
      }
    }

    // 修改密码按钮点击事件
    const handleModifyPassword = () => {
      // 重置表单
      Object.assign(form, {
        oldPwd: '',
        newPwd: '',
        confirmPwd: ''
      })
      showPasswordDialog.value = true
    }

    // 加载店铺信息
    const loadShopInfo = async () => {
      try {
        const response = await axios.get(`${config.BASE_URL}/shop/api/web_icon.php`)
        if (response.data.success) {
          shopLogo.value = response.data.data.shop_logo || '@/assets/logo.gif'
          shopName.value = response.data.data.shop_name || '商户端'
        }
      } catch (error) {
        console.error('加载店铺信息失败:', error)
        // 使用默认值
        shopLogo.value = '@/assets/logo.gif'
        shopName.value = '商户端'
      }
    }


    onMounted(() => {
      loadPoints()
      loadShopInfo() // 新增：加载店铺信息
      fetchModuleStatus(); // 新增：加载模块权限
      fetchPluginStatus(); // 新增：加载插件权限


    })

    const handleNavClick = (type) => {
      const messages = {
        distribution: '分销中心正在开发中，请稍后...',
        discount: '优惠套餐正在开发中，请稍后...'
      }
      ElMessage.info(messages[type] || '功能开发中')
    }
    const handleLogout = async () => {
      try {
        // 二次确认弹窗
        await ElMessageBox.confirm(
          '确定要退出登录吗？所有未保存数据将会丢失！',
          '警告',
          {
            confirmButtonText: '确认退出',
            cancelButtonText: '取消',
            type: 'warning',
            customClass: 'logout-confirm',
            closeOnClickModal: false
          }
        )

        // 清除登录状态
        Cookies.remove('user_token')
        Cookies.remove('user_info')
        isLoggedIn.value = false

        // 跳转登录页并提示
        router.push('/login')
        ElMessage.success('您已安全退出系统')
      } catch (error) {
        // 用户取消退出时不执行操作
        if (error !== 'cancel') {
          ElMessage.error('退出操作失败，请重试')
        }
      }
    }

    return {
      menuBgColor,
      isCollapse,
      points,
      userAvatar,
      username,
      activeMenu,
      sqNum,          // 新增
      formattedOutDate, // 新增
      handleLogout,
      handleNavClick,
      showPasswordDialog,
      form,
      showCardDialog,
      cardForm,
      showCardRechargeDialog,
      submitCardRecharge,
      submitPassword,
      shopLogo,
      shopName,
      moduleStatus,
      pluginStatus,
      userInfo,
      handleModifyPassword
    }
  }
}
</script>

<style scoped lang="scss">
$sidebar-w: 240px;
$sidebar-bg: #0f172a;
$sidebar-hover: rgba(255, 255, 255, 0.06);
$sidebar-active-bg: rgba(59, 130, 246, 0.12);
$navbar-h: 56px;
$text-muted: #94a3b8;
$text-active: #e2e8f0;
$accent: #3b82f6;
$transition: 0.2s ease;

.main-container {
  display: flex;
  height: 100vh;
  background: #f1f5f9;
  overflow: hidden;
}

/* ========== Sidebar ========== */
.sidebar {
  width: $sidebar-w;
  min-width: $sidebar-w;
  background: $sidebar-bg;
  display: flex;
  flex-direction: column;
  transition: width $transition;
  position: relative;
  z-index: 101;
}

.sidebar-header {
  padding: 20px 20px 16px;
}

.logo-area {
  display: flex;
  align-items: center;
  gap: 12px;

  .logo-img {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    object-fit: cover;
    flex-shrink: 0;
  }

  .logo-text {
    font-size: 15px;
    font-weight: 600;
    color: $text-active;
    letter-spacing: 0.3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.sidebar-divider {
  margin: 0 20px;
  height: 1px;
  background: rgba(255, 255, 255, 0.06);
}

.nav-menu {
  --el-menu-bg-color: transparent;
  --el-menu-hover-bg-color: transparent;
  flex: 1;
  padding: 8px 10px;
  overflow-y: auto;
  overflow-x: hidden;

  :deep(.el-sub-menu__title),
  :deep(.el-menu-item) {
    height: 40px;
    line-height: 40px;
    margin: 2px 0;
    border-radius: 6px;
    padding: 0 14px !important;
    font-size: 13.5px;
    transition: all $transition;

    .el-icon {
      font-size: 17px;
      flex-shrink: 0;
      width: 20px;
      text-align: center;
      margin-right: 10px;
    }

    &:hover {
      background: $sidebar-hover !important;
      color: $text-active !important;
    }
  }

  :deep(.el-menu-item.is-active) {
    background: $sidebar-active-bg !important;
    color: $accent !important;
    font-weight: 500;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 8px;
      bottom: 8px;
      width: 3px;
      background: $accent;
      border-radius: 0 3px 3px 0;
    }
  }

  :deep(.el-sub-menu) {
    .el-sub-menu__icon-arrow {
      right: 14px !important;
      margin-top: -6px !important;
      color: $text-muted;
    }

    .el-menu-item {
      padding-left: 48px !important;
      font-size: 13px;

      &.is-active::before {
        left: 0;
      }
    }
  }

  :deep(.el-menu) {
    background: transparent;
  }
}

/* ========== Content Wrapper ========== */
.content-wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  min-width: 0;
}

/* ========== Top Navbar ========== */
.fixed-top {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  height: $navbar-h;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 28px;
  border-bottom: 1px solid #e2e8f0;

  .nav-center {
    display: flex;
    align-items: center;
    gap: 0;
    margin-right: auto;

    .info-item {
      display: flex;
      align-items: center;
      gap: 6px;
      padding: 6px 16px;

      &:not(:last-child) {
        border-right: 1px solid #e2e8f0;
      }

      .info-dot {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        flex-shrink: 0;

        &.dot-points { background: #3b82f6; }
        &.dot-auth   { background: #22c55e; }
        &.dot-expire { background: #f59e0b; }
      }

      .info-label {
        font-size: 12.5px;
        color: #64748b;
        letter-spacing: 0.2px;
      }

      .info-value {
        font-size: 13px;
        font-weight: 600;
        color: #1e293b;
        font-variant-numeric: tabular-nums;
      }
    }
  }

  .nav-right {
    margin-left: 16px;
  }

  .user-info {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    border-radius: 8px;
    cursor: pointer;
    transition: background $transition;

    &:hover {
      background: #f1f5f9;
    }

    .el-avatar {
      flex-shrink: 0;
    }

    .username {
      font-size: 13.5px;
      color: #334155;
      font-weight: 500;
    }

    .arrow-icon {
      color: #94a3b8;
      font-size: 12px;
    }
  }
}

/* ========== Main Content ========== */
.main-content-container {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 24px;
  background: #f1f5f9;
}

.main-content {
  max-width: 1400px;
  margin: 0 auto;
}

/* ========== Dialog Form ========== */
.el-form-item {
  margin-bottom: 20px;
}

.el-input {
  width: 100%;
}

/* ========== Scrollbar ========== */
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;

  &:hover {
    background: #94a3b8;
  }
}

::-webkit-scrollbar-track {
  background: transparent;
}
</style>